import { createUseStyles } from 'react-jss'

export const style = {
  legendRect: {
    width: 10,
    height: 10,
    marginTop: 1
  },
  legendLabel: {
    marginLeft: 4
  },
  disabledKey: {
    opacity: '0.5'
  }
}

export const useStyles = createUseStyles(style)
